export const MAX_IMAGE_UPLOAD_SIZE = 10485760;
export const MAX_PDF_UPLOAD_SIZE = 10485760;
export const ACCEPTABLE_IMAGE_EXTENSIONS = [ '.jpg', '.jpeg', '.png' ];
export const ACCEPTABLE_IMAGE_FORMATS_LIST = [ 'image/jpeg', 'image/png' ];